import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_AD_67 } from "@/lib/programData";

export default function AtlasDesierto67Page() {
  return <ProgramTemplate program={PROGRAM_AD_67} variant="ad" showJourneyChronology />;
}
